<style>
    .field {
        padding-top: 5px;
        padding-bottom: 5px;
    }

    input {
        width: 250px;
        margin-top: 5px;
    }
</style>

<script>
    import { getContext } from 'svelte';
    const { close } = getContext('simple-modal');

    export let updateAccount;

    let password = '';
    function submit() {
        close()
        updateAccount(password)
    }
</script>

<h1>Update Account</h1>
<p>
    Please enter your current password to confirm you want to update your account details.
</p>
<div class="field">
    <input type="password" bind:value={password} placeholder="Current Password">
</div>
<div class="field">
    <button on:click={submit}>Update My Account</button>
</div>
